<template>
    <div class="w3w">
        <p class="w3w--title">{{$t('WHAT_3_WORDS_TITLE')}}</p>
        <p class="w3w--text">{{$t('WHAT_3_WORDS_TEXT')}}<br>
            <a href="https://freddiesflowers.delivery.w3w.co/" target="_blank" class="w3w--text--link">{{$t('WHAT_3_WORDS_LINK')}}</a>
        </p>
        <div class="w3w--graphic">
            <div class="w3w--graphic--1" data-content="1">{{$t('WHAT_3_WORDS_SEARCH')}}</div>
            <div class="w3w--graphic--2" data-content="2">{{$t('WHAT_3_WORDS_LOCATE')}}</div>
            <div class="w3w--graphic--3" data-content="3" v-html="$t('WHAT_3_WORDS_COPY')" />
        </div>
        <what3words-autosuggest class="w3w--input" :api_key="apiKey">
          <input
            type="text"
            id="what3words1"
            name="what3words1"
            :value="value"
            optional
            :placeholder="$t('WHAT_3_WORDS_INPUT_PLACEHOLDER')"/>
        </what3words-autosuggest>
    </div>
</template>

<script>

export default {
    name: 'What3Words',
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            apiKey: process.env.VUE_APP_W3W_API_KEY,
        };
    },
    created() {
        let w3w_sc1 = document.createElement('script');
        w3w_sc1.src = 'https://cdn.what3words.com/javascript-components@4-latest/dist/what3words/what3words.esm.js';
        w3w_sc1.type = 'module';
        w3w_sc1.id = 'w3w_sc1';
        document.getElementsByTagName('body')[0].appendChild(w3w_sc1);

        let w3w_sc2 = document.createElement('script');
        w3w_sc2.src = `https://cdn.what3words.com/javascript-components@4-latest/dist/what3words/what3words.js?key=${this.apiKey}`;
        w3w_sc2.type = 'module';
        w3w_sc2.id = 'w3w_sc2';
        document.getElementsByTagName('body')[0].appendChild(w3w_sc2);
    },
    destroyed() {
        let scr1 = document.getElementById('w3w_sc1');
        scr1.parentNode.removeChild(scr1);
        let scr2 = document.getElementById('w3w_sc2');
        scr2.parentNode.removeChild(scr2);
    },
};
</script>

<style lang="scss" scoped>
$greenColor: #63A75E;
.w3w {
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid $greenColor;
    &--title {
        font-weight: 400;
        font-size: 18px;
        margin: 0;
    }
    &--text {
        font-size: 14px;
        &--link {
            font-size: 14px;
            text-decoration: underline;
            color: $greenColor;
        }
    }
    &--graphic {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-content: center;
        text-align: center;
        margin: 20px 10px;
        &--1, &--2, &--3 {
            position: relative;
            color: $greenColor;
            font-size: 14px;
            font-weight: 400;
            padding: 10px;
            &::before {
                content: attr(data-content);
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background-color: $greenColor;
                color: white;
                position: absolute;
                top: -15px;
                left: calc(50% - 10px);
            }
        }
        &--1, &--2 {
            &::after {
                content: '';
                width: 100%;
                height: 1px;
                background-color: $greenColor;
                position: absolute;
                top: -5px;
                left: calc(50% + 10px);
            }
        }
    }
}
</style>

<style>
    .w3w--input {
        font-weight: 300;
        font-size: 16px;
        line-height: 18px;
        color: #262323;
        padding: 10px 20px;
        width: 100%;
        height: 50px;
        border-radius: 4px;
    }
    #what3words1 {
        background-color: #F7F7F7;
        border: none;
        color: #262323;
        border-radius: 4px;
    }
    #what3words1::placeholder {
        font-size: 16px;
        line-height: 18px;
        color: #262323;
        opacity: 0.5;
        font-family: 'Gill Sans';
    }
</style>
